import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { Store } from '@ngrx/store';
import { AddTeamMemberComponent } from '@src/suite/common/components/manage-team-members/team-member-item/add-team-member';
import { TeamMembersService } from '@src/suite/common/services/team-members-service';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { GlobalRoles } from '@src/suite/common/utils/util';
import { firstValueFrom, take } from 'rxjs';

@Component({
    selector: 'st-manage-team-members-main-cta',
    imports: [MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule],
    templateUrl: './manage-team-members-main-cta.component.html',
    styleUrl: './manage-team-members-main-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-manage-team-members-main-cta',
    },
})
export class ManageTeamMembersMainCtaComponent {
    store = inject(Store);
    dialog = inject(MatDialog);
    teamMembersService = inject(TeamMembersService);

    public roles: any[] = [];

    public teamMemberDialogRef: MatDialogRef<AddTeamMemberComponent, any> = null;

    readonly languageSettings = this.store.selectSignal(selectI18N)();

    async openNewMemberDialog() {
        const res = await firstValueFrom(this.teamMembersService.getTeamMembers());
        if (res && res.data) {
            const roles = JSON.parse(JSON.stringify(res.data));
            roles?.security.unshift(GlobalRoles.SUPERVISOR_ITEM);
            roles?.security.unshift(GlobalRoles.SERVER_MANAGER_ITEM);
            roles?.security.unshift(GlobalRoles.RESTRICTED_USER_ITEM);

            this.roles = roles;
        }
        this.dialog.closeAll();
        await firstValueFrom(this.dialog.afterAllClosed.pipe(take(1)));
        this.teamMemberDialogRef = this.dialog.open(AddTeamMemberComponent, {
            width: '35rem',
            hasBackdrop: true,
            panelClass: 'st-add-team-member-dialog',
            data: { data: this.roles },
        });
    }
}
